export default __webpack_public_path__ + "static/media/shoppingCart-discount-percent.f0086003.svg";